import mock from '../mock'
import jwt from 'jsonwebtoken'

// ** Third Party Components
import axios from 'axios'

// ** Custom Components
import GetApiCOC from '../../@fake-db/ApiCOC'

// ** Actions
import { handleLogin } from '@store/authentication'

// ** Utils
import { getUserData } from '@utils'

const data = {
  users: [
    {
      id: 1,
      username: '', 
      email: 'paulaestrada@city.com',
      password: 'cc0020c806139d7f7765',
      token:    'cc0020c806139d7f7765',
      role: 'admin',
      ability: [
        {
          action: 'manage',
          subject: 'all'
        }
      ],
      extras: {
        eCommerceCartItemsCount: 5
      }
    },    
    {
      id: 1,
      username: '', 
      email: 'jonathanarriaza@city.com',
      password: '#COC',
      token:    'a5d55c94cd95d587966d',
      role: 'admin',
      ability: [
        {
          action: 'manage',
          subject: 'all'
        }
      ],
      extras: {
        eCommerceCartItemsCount: 5
      }
    },    
    {
      id: 1,
      username: '', 
      email: 'leonelbarrios@city.com',
      password: 'cf647dfd8ec194d7b203',
      token:    'cf647dfd8ec194d7b203',
      role: 'admin',
      ability: [
        {
          action: 'manage',
          subject: 'all'
        }
      ],
      extras: {
        eCommerceCartItemsCount: 5
      }
    },
    {
      id: 1,
      username: '', 
      email: 'benjaminlopez@city.com',
      password: '2aee6b0905d42e1487b8',
      token:    '2aee6b0905d42e1487b8',
      role: 'admin',
      ability: [
        {
          action: 'manage',
          subject: 'all'
        }
      ],
      extras: {
        eCommerceCartItemsCount: 5
      }
    },
    {
      id: 1,
      username: '', 
      email: 'luciadelarosa@city.com',
      password: 'a114d796e81c35f8d5c1',
      token:    'a114d796e81c35f8d5c1',
      role: 'admin',
      ability: [
        {
          action: 'manage',
          subject: 'all'
        }
      ],
      extras: {
        eCommerceCartItemsCount: 5
      }
    },
    {
      id: 1,
      username: '', 
      email: 'wendygaldamez@city.com',
      password: 'eb332084b2c12efd2acc',
      token:    'eb332084b2c12efd2acc',
      role: 'admin',
      ability: [
        {
          action: 'manage',
          subject: 'all'
        }
      ],
      extras: {
        eCommerceCartItemsCount: 5
      }
    },
    {
      id: 1,
      username: '', 
      email: 'geraldinasasaki@city.com',
      password: '458362802aefdfff4863',
      token:    '458362802aefdfff4863',
      role: 'admin',
      ability: [
        {
          action: 'manage',
          subject: 'all'
        }
      ],
      extras: {
        eCommerceCartItemsCount: 5
      }
    }, 
    {
      id: 1,
      username: '', 
      email: 'superusuario@city.com',
      password: 'a5d55c94cd95d587966d',
      token:    'a5d55c94cd95d587966d',
      role: 'admin',
      ability: [
        {
          action: 'manage',
          subject: 'all'
        }
      ],
      extras: {
        eCommerceCartItemsCount: 5
      }
    },
    {
      id: 1,
      username: '', 
      email: 'gerente@city.com',
      password: 'd704d0e59e6aa7c8c00d',
      token:    'd704d0e59e6aa7c8c00d',
      role: 'admin',
      ability: [
        {
          action: 'manage@city.com',
          subject: 'all'
        }
      ],
      extras: {
        eCommerceCartItemsCount: 5
      }
    },
    {
      id: 1,
      username: '', 
      email: 'ejecutivo@city.com',
      password: '82bd5673eaeb1172b1d7',
      token:    '82bd5673eaeb1172b1d7',
      role: 'admin',
      ability: [
        {
          action: 'manage',
          subject: 'all'
        }
      ],
      extras: {
        eCommerceCartItemsCount: 5
      }
    },
    {
      id: 1,
      username: '', 
      email: 'asistente@city.com',
      password: '93761b610e5dab801307',
      token:    '93761b610e5dab801307',
      role: 'admin',
      ability: [
        {
          action: 'manage',
          subject: 'all'
        }
      ],
      extras: {
        eCommerceCartItemsCount: 5
      }
    },
    {
      id: 1,
      username: '', 
      email: 'rudyrosales@city.com',
      password: '004c4e120344d217f063',
      token:    '004c4e120344d217f063',
      role: 'admin',
      ability: [
        {
          action: 'manage',
          subject: 'all'
        }
      ],
      extras: {
        eCommerceCartItemsCount: 5
      }
    },
    {
      id: 1,
      username: '', 
      email: 'nancycortez@city.com',
      password: '7fdab736bee4c5544b7e',
      token:    '7fdab736bee4c5544b7e',
      role: 'admin',
      ability: [
        {
          action: 'manage',
          subject: 'all'
        }
      ],
      extras: {
        eCommerceCartItemsCount: 5
      }
    },
    {
      id: 1,
      username: '', 
      email: 'vestinagarrido@city.com',
      password: '9dff7936c4e9358816ef',
      token:    '9dff7936c4e9358816ef',
      role: 'admin',
      ability: [
        {
          action: 'manage',
          subject: 'all'
        }
      ],
      extras: {
        eCommerceCartItemsCount: 5
      }
    },
    {
      id: 1,
      username: '', 
      email: 'kammilventura@city.com',
      password: '1210103312fdd73f5b70',
      token:    '1210103312fdd73f5b70',
      role: 'admin',
      ability: [
        {
          action: 'manage',
          subject: 'all'
        }
      ],
      extras: {
        eCommerceCartItemsCount: 5
      }
    },
    {
      id: 1,
      username: '', 
      email: 'sandramata@city.com',
      password: '01556d9f13c973cc8297',
      token:    '01556d9f13c973cc8297',
      role: 'admin',
      ability: [
        {
          action: 'manage',
          subject: 'all'
        }
      ],
      extras: {
        eCommerceCartItemsCount: 5
      }
    },
    {
      id: 1,
      username: '', 
      email: 'lilianaborjas@city.com',
      password: 'f0aee85470be10d78714',
      token:    'f0aee85470be10d78714',
      role: 'admin',
      ability: [
        {
          action: 'manage',
          subject: 'all'
        }
      ],
      extras: {
        eCommerceCartItemsCount: 5
      }
    },
    {
      id: 1,
      username: '', 
      email: 'yonireyes@city.com',
      password: '0b4ee40cd49804e1a514',
      token:    '0b4ee40cd49804e1a514',
      role: 'admin',
      ability: [
        {
          action: 'manage',
          subject: 'all'
        }
      ],
      extras: {
        eCommerceCartItemsCount: 5
      }
    },
    {
      id: 1,
      username: '', 
      email: 'julioreyes@city.com',
      password: '3a4b859fb8524a58497a',
      token:    '3a4b859fb8524a58497a',
      role: 'admin',
      ability: [
        {
          action: 'manage',
          subject: 'all'
        }
      ],
      extras: {
        eCommerceCartItemsCount: 5
      }
    },
    {
      id: 1,
      username: '', 
      email: 'jonathanarriazacr@city.com',
      password: 'eddf05e11e0442e015c3',
      token:    'eddf05e11e0442e015c3',
      role: 'admin',
      ability: [
        {
          action: 'manage',
          subject: 'all'
        }
      ],
      extras: {
        eCommerceCartItemsCount: 5
      }
    },

    {
      id: 1,
      username: '', 
      email: 'a.ramirez@citymax-mx.com',
      password: 'b0b492053d625b3460c6',
      token:    'b0b492053d625b3460c6',
      role: 'admin',
      ability: [
        {
          action: 'manage',
          subject: 'all'
        }
      ],
      extras: {
        eCommerceCartItemsCount: 5
      }
    },
    {
      id: 1,
      username: '', 
      email: 's.gutierrez@citymax-la.com',
      password: '29b5aa411340f40eb55d',
      token:    '29b5aa411340f40eb55d',
      role: 'admin',
      ability: [
        {
          action: 'manage',
          subject: 'all'
        }
      ],
      extras: {
        eCommerceCartItemsCount: 5
      }
    },

    {
      id: 1,
      username: '', 
      email: 'oscargonzalez@city.com',
      password: '3e5aed7dcf93811df439',
      token:    '3e5aed7dcf93811df439',
      role: 'admin',
      ability: [
        {
          action: 'manage',
          subject: 'all'
        }
      ],
      extras: {
        eCommerceCartItemsCount: 5
      }
    },
    {
      id: 1,
      username: '', 
      email: 'yubelkisrodriguez@city.com',
      password: '47cf8954af66716eeceb',
      token:    '47cf8954af66716eeceb',
      role: 'admin',
      ability: [
        {
          action: 'manage',
          subject: 'all'
        }
      ],
      extras: {
        eCommerceCartItemsCount: 5
      }
    },
    {
      id: 1,
      username: '', 
      email: 'mesalinamarmolejos@city.com',
      password: 'b647673a9db5eba8955c',
      token:    'b647673a9db5eba8955c',
      role: 'admin',
      ability: [
        {
          action: 'manage',
          subject: 'all'
        }
      ],
      extras: {
        eCommerceCartItemsCount: 5
      }
    },
    {
      id: 1,
      username: '', 
      email: 'inesdealonzo@city.com',
      password: '7a0272aa1fff53e787b3',
      token:    '7a0272aa1fff53e787b3',
      role: 'admin',
      ability: [
        {
          action: 'manage',
          subject: 'all'
        }
      ],
      extras: {
        eCommerceCartItemsCount: 5
      }
    },
    {
      id: 1,
      username: '', 
      email: 'carolparedes@city.com',
      password: 'a20965268b65e0e3e69b',
      token:    'a20965268b65e0e3e69b',
      role: 'admin',
      ability: [
        {
          action: 'manage',
          subject: 'all'
        }
      ],
      extras: {
        eCommerceCartItemsCount: 5
      }
    },
    {
      id: 1,
      username: '', 
      email: 'anabellazepedab@city.com',
      password: '8c5221c0a5bf9b1c7f81',
      token:    '8c5221c0a5bf9b1c7f81',
      role: 'admin',
      ability: [
        {
          action: 'manage',
          subject: 'all'
        }
      ],
      extras: {
        eCommerceCartItemsCount: 5
      }
    },
    {
      id: 1,
      username: '', 
      email: 'valeskadegalindoa@city.com',
      password: '6cd888dd14f63eee81af',
      token:    '6cd888dd14f63eee81af',
      role: 'admin',
      ability: [
        {
          action: 'manage',
          subject: 'all'
        }
      ],
      extras: {
        eCommerceCartItemsCount: 5
      }
    },
    {
      id: 1,
      username: '', 
      email: 'waldemarlandaverde@city.com',
      password: 'cba99410237a7d01499f',
      token:    'cba99410237a7d01499f',
      role: 'admin',
      ability: [
        {
          action: 'manage',
          subject: 'all'
        }
      ],
      extras: {
        eCommerceCartItemsCount: 5
      }
    },
    {
      id: 1,
      username: '', 
      email: 'olgacalderond@city.com',
      password: 'ac59e87448fde7f2df99',
      token:    'ac59e87448fde7f2df99',
      role: 'admin',
      ability: [
        {
          action: 'manage',
          subject: 'all'
        }
      ],
      extras: {
        eCommerceCartItemsCount: 5
      }
    },
    {
      id: 1,
      username: '', 
      email: 'anyellacabrera@city.com',
      password: '39abfa4dbb77c6bcc4ad',
      token:    '39abfa4dbb77c6bcc4ad',
      role: 'admin',
      ability: [
        {
          action: 'manage',
          subject: 'all'
        }
      ],
      extras: {
        eCommerceCartItemsCount: 5
      }
    },
    {
      id: 1,
      username: '',
      email: 'alejandrahernandez@city.com',
      password: '64bb3f1fb2a79f42ceb0', 
      token:'64bb3f1fb2a79f42ceb0',
      role: 'admin',
      ability: [
        {
          action: 'manage',
          subject: 'all'
        }
      ],
      extras: {
        eCommerceCartItemsCount: 5
      }
    },
    {
      id: 1,
      username: '',
      email: 'carlasosa@city.com',
      password: '914365938d042fc908d7', 
      token:'914365938d042fc908d7',
      role: 'admin',
      ability: [
        {
          action: 'manage',
          subject: 'all'
        }
      ],
      extras: {
        eCommerceCartItemsCount: 5
      }
    },
    {
      id: 1,
      username: '',
      email: 'kammilventura@city.com',
      password: '3e9218c14de49491e086', 
      token:'3e9218c14de49491e086',
      role: 'admin',
      ability: [
        {
          action: 'manage',
          subject: 'all'
        }
      ],
      extras: {
        eCommerceCartItemsCount: 5
      }
    },
    {
      id: 1,
      username: '',
      email: 'santiagopocon@city.com',
      password: 'bd7ebb096de238721292', 
      token:'bd7ebb096de238721292',
      role: 'admin',
      ability: [
        {
          action: 'manage',
          subject: 'all'
        }
      ],
      extras: {
        eCommerceCartItemsCount: 5
      }
    },
    {
      id: 1,
      username: '',
      email: 'albertomendizabal@city.com',
      password: '3a93c7342c35b82043dc', 
      token:'3a93c7342c35b82043dc',
      role: 'admin',
      ability: [
        {
          action: 'manage',
          subject: 'all'
        }
      ],
      extras: {
        eCommerceCartItemsCount: 5
      }
    },
    {
      id: 1,
      username: '',
      email: 'henrynaveo@city.com',
      password: '9d978d980e1b94f4b4ed', 
      token:'9d978d980e1b94f4b4ed',
      role: 'admin',
      ability: [
        {
          action: 'manage',
          subject: 'all'
        }
      ],
      extras: {
        eCommerceCartItemsCount: 5
      }
    },
    {
      id: 1,
      username: '',
      email: 'andreinayusti@city.com',
      password: '716ef757ce8d217b98c6', 
      token:'716ef757ce8d217b98c6',
      role: 'admin',
      ability: [
        {
          action: 'manage',
          subject: 'all'
        }
      ],
      extras: {
        eCommerceCartItemsCount: 5
      }
    },
    {
      id: 1,
      username: '',
      email: 'armandogutierrez@city.com',
      password: '239e607d9a1f1d81599f', 
      token:'239e607d9a1f1d81599f',
      role: 'admin',
      ability: [
        {
          action: 'manage',
          subject: 'all'
        }
      ],
      extras: {
        eCommerceCartItemsCount: 5
      }
    },
    {
      id: 1,
      username: '',
      email: 'claudiapivaral@city.com',
      password: 'b750eefce0b315c91302', 
      token:'b750eefce0b315c91302',
      role: 'admin',
      ability: [
        {
          action: 'manage',
          subject: 'all'
        }
      ],
      extras: {
        eCommerceCartItemsCount: 5
      }
    },
    {
      id: 1,
      username: '',
      email: 'auramazariegos@city.com',
      password: '3d6b4cab07abc4f6446e', 
      token:'3d6b4cab07abc4f6446e',
      role: 'admin',
      ability: [
        {
          action: 'manage',
          subject: 'all'
        }
      ],
      extras: {
        eCommerceCartItemsCount: 5
      }
    },
    {
      id: 1,
      username: '',
      email: 'arturorivas@city.com',
      password: 'f78cbb22531f86af50c6', 
      token:'f78cbb22531f86af50c6',
      role: 'admin',
      ability: [
        {
          action: 'manage',
          subject: 'all'
        }
      ],
      extras: {
        eCommerceCartItemsCount: 5
      }
    },
    {
      id: 1,
      username: '',
      email: 'claudiaalvarez@city.com',
      password: '1444566421696f58d7e6', 
      token:'1444566421696f58d7e6',
      role: 'admin',
      ability: [
        {
          action: 'manage',
          subject: 'all'
        }
      ],
      extras: {
        eCommerceCartItemsCount: 5
      }
    },
    {
      id: 1,
      username: '',
      email: 'carolinacastillo@city.com',
      password: '9dc55dd111ebcf8513cd', 
      token:'9dc55dd111ebcf8513cd',
      role: 'admin',
      ability: [
        {
          action: 'manage',
          subject: 'all'
        }
      ],
      extras: {
        eCommerceCartItemsCount: 5
      }
    },
    {
      id: 1,
      username: '',
      email: 'alexanderlopez@city.com',
      password: 'fcd59e728423116e25c6', 
      token:'fcd59e728423116e25c6',
      role: 'admin',
      ability: [
        {
          action: 'manage',
          subject: 'all'
        }
      ],
      extras: {
        eCommerceCartItemsCount: 5
      }
    },
    {
      id: 1,
      username: '',
      email: 'abelglass@city.com',
      password: '44db1be789b134ed5112', 
      token:'44db1be789b134ed5112',
      role: 'admin',
      ability: [
        {
          action: 'manage',
          subject: 'all'
        }
      ],
      extras: {
        eCommerceCartItemsCount: 5
      }
    },
    {
      id: 1,
      username: '',
      email: 'christianmotta@city.com',
      password: '725414b5155f0f81899c', 
      token:'725414b5155f0f81899c',
      role: 'admin',
      ability: [
        {
          action: 'manage',
          subject: 'all'
        }
      ],
      extras: {
        eCommerceCartItemsCount: 5
      }
    },
    {
      id: 1,
      username: '',
      email: 'erikahuitz@city.com',
      password: '73a4674ca540248843f1', 
      token:'73a4674ca540248843f1',
      role: 'admin',
      ability: [
        {
          action: 'manage',
          subject: 'all'
        }
      ],
      extras: {
        eCommerceCartItemsCount: 5
      }
    },
    {
      id: 1,
      username: '',
      email: 'andreamoreno@city.com',
      password: 'c6aa7fa31fc7e72007b1', 
      token:'c6aa7fa31fc7e72007b1',
      role: 'admin',
      ability: [
        {
          action: 'manage',
          subject: 'all'
        }
      ],
      extras: {
        eCommerceCartItemsCount: 5
      }
    },
    {
      id: 1,
      username: '',
      email: 'adolfoobregon@city.com',
      password: '5004589e169e86b57dc0', 
      token:'5004589e169e86b57dc0',
      role: 'admin',
      ability: [
        {
          action: 'manage',
          subject: 'all'
        }
      ],
      extras: {
        eCommerceCartItemsCount: 5
      }
    },
    {
      id: 1,
      username: '',
      email: 'josetavarez@city.com',
      password: 'a005ba103f880cf8e4bb', 
      token:'a005ba103f880cf8e4bb',
      role: 'admin',
      ability: [
        {
          action: 'manage',
          subject: 'all'
        }
      ],
      extras: {
        eCommerceCartItemsCount: 5
      }
    },
    {
      id: 1,
      username: '',
      email: 'katherinedelossantos@city.com',
      password: '740e388522890b44008c',
      token: '740e388522890b44008c',
      role: 'admin',
      ability: [
        {
          action: 'manage',
          subject: 'all'
        }
      ],
      extras: {
          eCommerceCartItemsCount: 5
      }
      },
      {
        id: 1,
        username: '',
        email: 'susanordoneza@city.com',
        password: 'dee124425c961ecc15ef',
        token: 'dee124425c961ecc15ef',
        role: 'admin',
        ability: [
          {
            action: 'manage',
            subject: 'all'
          }
        ],
        extras: {
            eCommerceCartItemsCount: 5
        }
      },
      {
        id: 1,
        username: '',
        email: 'robertocastaneda@city.com',
        password: 'badbb62008e30546526c',
        token: 'badbb62008e30546526c',
        role: 'admin',
        ability: [
          {
            action: 'manage',
            subject: 'all'
          }
        ],
        extras: {
            eCommerceCartItemsCount: 5
        }
      },
      {
        id: 1,
        username: '',
        email: 'alexgarzaro@city.com',
        password: '49b71138378e7790b0d6',
        token: '49b71138378e7790b0d6',
        role: 'admin',
        ability: [
          {
            action: 'manage',
            subject: 'all'
          }
        ],
        extras: {
            eCommerceCartItemsCount: 5
        }
      },
      {
        id: 1,
        username: '',
        email: 'sheilaencarnacion@city.com',
        password: '078ec0c9286f7ef005bc',
        token: '078ec0c9286f7ef005bc',
        role: 'admin',
        ability: [
          {
            action: 'manage',
            subject: 'all'
          }
        ],
        extras: {
            eCommerceCartItemsCount: 5
        }
      }
  ]
}

// ! These two secrets shall be in .env file and not in any other file
const jwtConfig = {
  secret: 'dd5f3089-40c3-403d-af14-d0c228b05cb4',
  refreshTokenSecret: '7c4c1c50-3230-45bf-9eae-c9b2e401c767',
  expireTime: '10m',
  refreshTokenExpireTime: '10m'
}

mock.onPost('/jwt/login').reply(async request => {

  const { email, password, type, tokenCOC } = JSON.parse(request.data)

  let error = {
    email: ['Something went wrong']
  }

  if (type === 'manual') {

    const user = data.users.find(u => u.email === email && u.password === password)

    if (user) {
      try {
        //obtiene token
        const body = {
          email:    "jsimon@4consultinggroup.com",
          password: "aWc&WA9h6@"
        }

        const configws = {
          method: 'post',
          url:    GetApiCOC('login'),
          headers: { 
            Accept:'application/json'
          },
          params: body
        }

        const responsews = await axios(configws)
        const accessToken = responsews.data.access_token
        const refreshToken = responsews.data.access_token

        const userData = { ...user }

        delete userData.password

        const response = {
          userData,
          accessToken,
          refreshToken
        }

        return [200, response]
      } catch (e) {
        error = e
      }
    } else {
      error = {
        email: ['Email or Password is Invalid']
      }
    }
  } else if (type === 'obrien') {
      try {
        //obtiene token
        const body = {
          email:    "jsimon@4consultinggroup.com",
          password: "aWc&WA9h6@"
        }

        const configws = {
          method: 'post',
          url:    GetApiCOC('login'),
          headers: { 
            Accept:'application/json'
          },
          params: body
        }

        const responsews = await axios(configws)
        const accessToken = responsews.data.access_token
        const refreshToken = responsews.data.access_token

        const user = {
          id       : 1,
          username : 'coc',
          email    : 'coc@city.com',
          token    : tokenCOC,
          role: 'admin',
          ability: [
            {
              action: 'manage',
              subject: 'all'
            }
          ]
        }

        const userData = { ...user }

        const response = {
          userData,
          accessToken,
          refreshToken
        }

        return [200, response]
      } catch (e) {
        error = e
      }
  }

  return [400, { error }]
})

mock.onPost('/jwt/register').reply(request => {
  if (request.data.length > 0) {
    const { email, password, username } = JSON.parse(request.data)
    const isEmailAlreadyInUse = data.users.find(user => user.email === email)
    const isUsernameAlreadyInUse = data.users.find(user => user.username === username)
    const error = {
      email: isEmailAlreadyInUse ? 'This email is already in use.' : null,
      username: isUsernameAlreadyInUse ? 'This username is already in use.' : null
    }

    if (!error.username && !error.email) {
      const userData = {
        email,
        password,
        username,
        fullName: '',
        avatar: null,
        role: 'admin',
        ability: [
          {
            action: 'manage',
            subject: 'all'
          }
        ]
      }

      // Add user id
      const length = data.users.length
      let lastIndex = 0
      if (length) {
        lastIndex = data.users[length - 1].id
      }
      userData.id = lastIndex + 1

      data.users.push(userData)

      const accessToken = jwt.sign({ id: userData.id }, jwtConfig.secret, { expiresIn: jwtConfig.expireTime })

      const user = Object.assign({}, userData)
      delete user['password']
      const response = { user, accessToken }

      return [200, response]
    } else {
      return [200, { error }]
    }
  }
})

mock.onPost('/jwt/refresh-token').reply(async request => {
  const { refreshToken } = JSON.parse(request.data)

  console.log(refreshToken)

  try {
    //const { id } = jwt.verify(refreshToken, jwtConfig.refreshTokenSecret)
    //const userData = { ...data.users.find(user => user.id === id) }

    let userData = getUserData()   

    const configws = {
      method: 'post',
      url:    GetApiCOC('refresh')
    }

    const responsews = await axios(configws)

    const newAccessToken = responsews.data.authorisation.token
    const newRefreshToken = responsews.data.authorisation.token

    userData = { ...userData, accessToken: newAccessToken, refreshToken: newRefreshToken }
    handleLogin(data)

    //const newAccessToken = jwt.sign({ id: userData.id }, jwtConfig.secret, { expiresIn: jwtConfig.expiresIn })
    //const newRefreshToken = jwt.sign({ id: userData.id }, jwtConfig.refreshTokenSecret, {
    //  expiresIn: jwtConfig.refreshTokenExpireTime
    //})

    delete userData.password
    const response = {
      userData,
      accessToken: newAccessToken,
      refreshToken: newRefreshToken
    }

    return [200, response]
  } catch (e) {
    const error = 'Invalid refresh token'
    return [401, { error }]
  }
})
